import { MediaMatcher } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthService } from 'src/app/_services/auth.service';
import { NotificationService } from 'src/app/_services/notification.service';
import { ProfileService } from 'src/app/_services/profile.service';
import { StorageService } from 'src/app/_services/storage.service';
import { UtilityService } from 'src/app/_services/utility.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  userRole: any;
  sidenav: any;
  toggler: any;
  sidenavClosed$: any;
  sidebarService: any;
  logo: any;
  path: any;
  profileData: any;
  role: any;
  lastSegment: string = '';
  pageTitle: string = '';

  constructor(
    private readonly router: Router,
    private readonly sanitizer: DomSanitizer,
    private readonly profileService: ProfileService,
    private readonly titleService: UtilityService
  ) {
    this.profileService.getImg();
  }

  async ngOnInit(): Promise<void> {
    this.profileService.getImg().subscribe({
      next: (value: any) => {
        if (value != null) this.getSantizeUrl(value);
      }
    });

    this.profileData = await this.profileService.getUserRoleAsync();
    if (this.profileData?.filestorage?.path) {
      this.getSantizeUrl(this.profileData.filestorage.path);
    }

    if (environment.production) {
      this.logo = 'assets/images/loghi/newLogo.svg';
    } else if (environment.local) {
      this.logo = 'assets/images/loghi/newLogoLocal.svg';
    } else {
      this.logo = 'assets/images/loghi/newLogoDev.svg';
    }

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.lastSegment = this.getLastSegment(event.url);
      }
    });

    this.titleService.getTitle().subscribe((title: string) => {
      this.pageTitle = title;
    });
  }

  getSantizeUrl(url: string) {
    this.path = environment.file + url;

    return this.sanitizer.bypassSecurityTrustUrl(this.path);
  }

  getLastSegment(url: string): string {
    const segments = url.split('/');
    const lastSegment = segments[segments.length - 1];

    // Verifica se l'ultimo segmento è un numero
    if (!isNaN(Number(lastSegment))) {
      // Se è un numero, restituisci il segmento precedente
      const penultimateSegment = segments[segments.length - 2];
      return penultimateSegment.replace(/-/g, ' ').toUpperCase(); // Sostituisci tutti i trattini con spazi
    } else {
      // Altrimenti, restituisci l'ultimo segmento
      return lastSegment.replace(/-/g, ' ').toUpperCase(); // Sostituisci tutti i trattini con spazi
    }
  }

  getDescription(): string {
    switch (true) {
      case this.pageTitle === 'Review':
        return `La sezione Review è uno spazio dedicato alla valorizzazione del tuo percorso. Qui vengono raccolte tutte le azioni significative che hai svolto all'interno dell'applicativo, offrendo una panoramica completa del tuo contributo. Oltre alle attività individuali, puoi consultare statistiche dettagliate legate ai team di cui fai parte, per comprendere meglio il tuo impatto nel contesto collaborativo. Questa sezione ti aiuta a riflettere sui risultati ottenuti, a evidenziare i progressi compiuti e a prepararti in modo efficace per momenti di confronto, feedback o valutazione.`;

      case this.pageTitle === 'SBI':
        return `La sezione SBI (Situation – Behavior – Impact) è pensata per raccogliere e valorizzare feedback strutturati e significativi. Ogni scheda descrive una situazione specifica, il comportamento osservato e l'impatto generato, offrendo così uno strumento concreto per riconoscere atteggiamenti positivi, favorire il miglioramento continuo e supportare la crescita professionale. Attraverso questo formato, è possibile documentare episodi rilevanti, stimolare la consapevolezza e promuovere una cultura del feedback costruttivo all'interno del team.`;

      case this.pageTitle === 'I miei team':
        return `In questa sezione puoi visualizzare tutti i team di cui fai parte, con una panoramica delle principali statistiche e attività di ciascun gruppo. È uno spazio pensato per tenere traccia del tuo coinvolgimento nei vari team, monitorare l'andamento collettivo e restare sempre aggiornato sul contributo del gruppo.`;

      case this.pageTitle === 'Sondaggi':
        return `In questa sezione puoi creare o rispondere a sondaggi semplici, composti da domande a risposta multipla, valutazione su scala o risposta aperta. Uno strumento utile per raccogliere opinioni, preferenze o impressioni in modo rapido e strutturato.`;

      case this.pageTitle === 'Feedback360':
        return `Sezione dedicata alla valutazione delle competenze trasversali. Con il Feedback 360, più utenti valutano un collega su una serie di domande, assegnando punteggi da 0 a 10. I risultati contribuiscono al profilo Competenze dell'utente valutato. L'Autovalutazione segue lo stesso schema, ma viene compilata dall'utente su se stesso. Uno strumento pensato per stimolare il confronto, la consapevolezza e la crescita professionale.`;

      case this.pageTitle === 'Time Sheet':
        return `In questa sezione puoi visualizzare il tuo timesheet suddiviso per team, con il dettaglio delle ore dedicate sia alle attività di sviluppo che a quelle di fatturazione. Uno strumento utile per tenere traccia del tempo investito nei progetti, migliorare la pianificazione e garantire una gestione efficace delle risorse.`;

      case this.pageTitle === 'Feedback':
        return `Una sezione dedicata alla raccolta di segnalazioni e suggerimenti da parte degli utenti dell'applicativo. Qui è possibile inviare feedback relativi a bug riscontrati, proposte di miglioramento, richieste di integrazione di nuove tecnologie e molto altro. Uno spazio pensato per favorire il miglioramento continuo della piattaforma attraverso il contributo diretto di chi la utilizza ogni giorno.`;

      default:
        return '';
    }
  }
}
